Controller.$inject = ['$timeout'];

function Controller($timeout) {
    const self = this;
    self.$postLink = () => {
        self.isSticky = self.isSticky !== false;
    };
}

export function HuiPageHeader() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {
            isSticky: '<',
        },
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return ` <div class="hui px-4 py-1 hui-page-header"
                          ng-class="{'sticky': $huiCtrl.isSticky}"
                          ng-transclude></div>`;
        }
    };
}